import React from "react";
import { Box, Typography } from "@mui/material";
import { formatCurrencyManual } from "../../utils/formatters";
import { Num } from "../../components/ui";
import { tokens } from "../../theme";

/**
 * Totales de la orden. Quedan fijos debajo de la barra superior mientras se
 * cargan los detalles, así el TOTAL siempre está a la vista.
 */
const Totals = ({ totalExpenses, totalExpensesWithIva, iva105, iva21, currencySymbol }) => {
  const symbol = currencySymbol ?? '$';

  const items = [
    { label: "IVA 10,5%", value: iva105 },
    { label: "IVA 21%", value: iva21 },
    { label: "Sub total", value: totalExpenses },
    { label: "TOTAL", value: totalExpensesWithIva, destacado: true },
  ];

  return (
    <Box
      sx={{
        position: "sticky",
        // La barra superior mide 56 px en teléfono y 64 en escritorio.
        top: { xs: "56px", md: `${tokens.topbarHeight}px` },
        zIndex: 10,
        backgroundColor: tokens.canvas,
        paddingTop: "8px",
        paddingBottom: "8px",
        marginTop: "-8px",
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))" },
        gap: { xs: "8px", md: "10px" },
        width: "100%",
        minWidth: 0,
      }}
    >
      {items.map(({ label, value, destacado }) => (
        <Box
          key={label}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            minWidth: 0,
            padding: { xs: "11px 12px", md: "12px 14px" },
            borderRadius: `${tokens.radiusCard}px`,
            border: `1px solid ${destacado ? tokens.brandBorder : tokens.border}`,
            backgroundColor: destacado ? tokens.brandTint : tokens.surface,
          }}
        >
          <Typography
            sx={{
              fontSize: "11.5px",
              fontWeight: destacado ? 600 : 500,
              color: destacado ? tokens.brandDarker : tokens.ink3,
              letterSpacing: destacado ? "0.06em" : "normal",
            }}
          >
            {label}
          </Typography>
          <Num
            sx={{
              fontSize: { xs: destacado ? "16px" : "15px", md: destacado ? "18px" : "16.5px" },
              fontWeight: 600,
              lineHeight: 1.15,
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: destacado ? tokens.brandDarker : tokens.ink,
            }}
            title={formatCurrencyManual(value, symbol)}
          >
            {formatCurrencyManual(value, symbol)}
          </Num>
        </Box>
      ))}
    </Box>
  );
};

export default Totals;
